module.exports = __webpack_public_path__ + "img/10n.ad03b616.gif";